module.exports = __webpack_public_path__ + "img/message-button-icon.30e0b740.svg";